import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };

const fields = [
    'agentProfileId',
    'agentContactId',
    'referralType',
    'salesRepresentative',
    'agentPreferences',
    'preferredEmail',
    'subscriberId',
    'brokeragePreferences',
];

const labels = {
    agentProfileId: '',
    agentContactId: '',
    referralType: 'Referral Method',
    salesRepresentative: 'Sales Representative',
    agentPreferences: 'Agent Preferences',
    preferredEmail: 'Preferred Email',
    subscriberId: '',
    //label for brokerage preferences set below
};
const rules = {
 // validate here not only the email format, also that you enter more than one email with ',' separated.
    preferredEmail:  ['required','regex:/^([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}(,|$))+$/'],
};

const disabledAll = {
    agentProfileId: true,
    agentContactId: true,
    referralType: true,
    salesRepresentative: true,
    agentPreferences: true,
    preferredEmail: true,
    subscriberId: true,
    brokeragePreferences: true,
};

const disabledTc = {
    brokeragePreferences: true,
};

export default function(appStore) {

    var nameBroker = appStore.agentProfileStore.selectedAgentBrokerageName;
   if(appStore.tcFileStore.selectedFile != null)
   {
    nameBroker =  appStore.tcFileStore.selectedFile.subscriberName;
   }

    labels.brokeragePreferences = 'Brokerage Preferences: ' + nameBroker;

    if (appStore.permissionStore.can('agentprofile.edit') && appStore.permissionStore.can('brokerageprofile.edit')) {
        return new MobxReactForm({ fields, labels, rules }, { plugins });
    } else if (appStore.permissionStore.can('agentprofile.edit')) {
        return new MobxReactForm({ fields, labels, disabled: disabledTc, rules }, { plugins });
    } else {
        return new MobxReactForm({ fields, labels, disabled: disabledAll, rules }, { plugins });
    }
}



// WEBPACK FOOTER //
// ./src/agent-profile/agent-profile-form-component.js